module.exports = __webpack_public_path__ + "img/MObanner-3.5c17d354.jpg";